'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/function-bind@1.1.2/~/function-bind/index.js
// module id = 107
// module chunks = 0